export const PROFILE_NAME_VARIABLE = "wa:profile:name";
export const PROFILE_TEXTURES_VARIABLE = "wa:profile:textures";
export const PROFILE_COMPANION_VARIABLE = "wa:profile:companion";
